import { Currency, Token } from '@uniswap/sdk-core'

import { ANI, HYUSD } from '../../constants/tokens'

/**
 * Check if a currency is the ANI token
 */
export function isAniToken(currency: Currency | null | undefined): boolean {
  if (!currency || currency.isNative) return false
  const token = currency as Token
  return token.equals(ANI)
}

/**
 * Check if a currency is hyUSD
 */
export function isHyUsdToken(currency: Currency | null | undefined): boolean {
  if (!currency || currency.isNative) return false
  const token = currency as Token
  return token.equals(HYUSD)
}

/**
 * Determine if a swap involves ANI token
 * Returns the ANI direction if it's an ANI swap, null otherwise
 */
export function detectAniSwap(
  inputCurrency: Currency | null | undefined,
  outputCurrency: Currency | null | undefined
): 'buy' | 'sell' | null {
  if (isAniToken(outputCurrency)) {
    return 'buy' // Buying ANI (token -> ANI)
  }
  if (isAniToken(inputCurrency)) {
    return 'sell' // Selling ANI (ANI -> token)
  }
  return null
}

/**
 * Check if a swap is a direct hyUSD <-> ANI swap (no DEX leg needed)
 */
export function isDirectAniSwap(
  inputCurrency: Currency | null | undefined,
  outputCurrency: Currency | null | undefined
): boolean {
  const aniDirection = detectAniSwap(inputCurrency, outputCurrency)
  if (!aniDirection) return false

  // Direct swap if the non-ANI side is hyUSD
  if (aniDirection === 'buy') {
    return isHyUsdToken(inputCurrency)
  } else {
    return isHyUsdToken(outputCurrency)
  }
}
